import { inject, Injectable } from '@angular/core';
import { CookieService } from './cookie.service';
import { CRYPTO_HASH_BT, DEBUG_OK } from '../constants/constants';
import { addListener, launch } from 'devtools-detector';

@Injectable({
  providedIn: 'root',
})
export class DevToolsDetectorService {
  cookieService = inject(CookieService);

  async setupDevToolsDetector() {
    const checkNeeded = await this.devToolsCheckNeeded();
    if (checkNeeded) {
      addListener(isOpen => {
        if (isOpen) {
          window.location.href =
            'resetApp.html?cb=' + new Date().valueOf() + '&upgradebecause=webdev';
        }
      });
      // 2. Launch detection
      launch();
    }
  }

  private async devToolsCheckNeeded() {
    if (location.origin === 'http://localhost:4200') {
      return false;
    }

    const checkStr = this.cookieService.get('_c');
    if (!checkStr) {
      return true;
    }

    const data = new TextEncoder().encode(checkStr + 'AdminType' + CRYPTO_HASH_BT);
    try {
      const result = await window.crypto.subtle.digest('SHA-256', data);
      const byteArray: Uint8Array = new Uint8Array(result);
      const hash = btoa(String.fromCharCode(...byteArray));
      return hash !== DEBUG_OK;
    } catch {
      return true;
    }
  }
}
